import BeleidBloedingenBijDeHuisarts from "../../../../src/client/lta-antistolling/beleid-bloedingen-bij-de-huisarts.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  BeleidBloedingenBijDeHuisarts,
  ChartCollapse,
  React
};